import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'caseOutRecordController';
export default {
    /**
     * 下载电催根据模板
     */
    downLoadMobileUrge: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'downLoadMobileUrge',
        type: requestType.Get
    },
    /**
     * 下载外访根据模板
     */
    downLoadOutVisit: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'downLoadOutVisit',
        type: requestType.Get
    }
};
